import z from "zod";
import { LabelType } from "__generated__/enums";

export const labelSchema = z.object({
	id: z.number().nullable(),
	text: z.string().min(1).max(255),
	color: z.string(),
	type: z.enum(LabelType),
});

export const labelSelectOptionSchema = z.object({
	id: z.number(),
	text: z.string(),
	type: z.enum(LabelType),
	color: z.string(),
});

export type LabelSchemaInput = z.input<typeof labelSchema>;
export type LabelSchemaOutput = z.output<typeof labelSchema>;
